// @flow

export default `
  fragment BookingAttendeesProfile on Profile {
    gmNumber
    civility
    firstName
    lastName
    unicodeFirstName
    unicodeLastName
  }
`;
